<template>
  <div class="unplatfollow-wrapper bj">
        <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="Refresh"
      @search="search"
      @selectChange="cityChange"
    >
      <template v-slot:right>
        <el-button
          :disabled="!tableData.length || disabledExport"
          @click="onHandleExport"
          type="warning"
          icon="el-icon-download"
          >导出</el-button
        >
      </template>
    </Filtersearch>
    <!-- <div class="title">
      <div class="seach order-wrapper">
        <div class="inputs">
          <span class="label">创建日期：</span>
          <el-date-picker
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            align="right"
            v-model="createDate"
            @change="changeCreateDate"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="inputs">
          <span class="label">完成日期：</span>
          <el-date-picker
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            align="right"
            v-model="finishDate"
            @change="changeFinishDate"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="inputs">
          <span class="label">支付日期：</span>
          <el-date-picker
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            align="right"
            v-model="payDate"
            @change="changePayDate"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="inputs">
          <span class="label">供货日期：</span>
          <el-date-picker
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            align="right"
            v-model="supplierDate"
            @change="changeSupplierDate"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="inputs">
         
          <el-input
            class="jn-input-style"
            v-model="formData.order_no"
            placeholder="请输入订单号"
            clearable
          ></el-input>
        </div>

        <div class="inputs">
        
          <el-input
            class="jn-input-style"
            v-model="formData.as_no"
            placeholder="请输入售后单号"
            clearable
          ></el-input>
        </div>
        <div class="inputs">
        
          <el-input
            class="jn-input-style"
            v-model="formData.mobile"
            placeholder="请输入客户电话"
            clearable
          ></el-input>
        </div>
        <div class="inputs">
         
          <el-input
            class="jn-input-style"
            v-model="formData.title"
            placeholder="请输入商品名称"
            clearable
          ></el-input>
        </div>
        <div class="inputs">
         
          <el-input
            class="jn-input-style"
            v-model="formData.sku_code"
            placeholder="请输入货号"
            clearable
          ></el-input>
        </div>
        <div class="inputs">
        
          <el-select
            class="jn-input-style"
            v-model="formData.cid"
            clearable
            filterable
            placeholder="请选择二级分类"
          >
            <el-option
              v-for="item in subCidList"
              :label="item.name"
              :key="item.id"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <div class="inputs">
          
          <el-select
            class="jn-input-style"
            v-model="formData.reason_type"
            clearable
            placeholder="请选择售后原因"
          >
            <el-option
              v-for="item in reasonList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="inputs">
          
          <el-select
            class="jn-input-style"
            v-model="formData.logistic_business_id"
            clearable
            placeholder="请选择集配中心"
          >
            <el-option
              v-for="item of businessList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="inputs">
          
          <el-select
            class="jn-input-style"
            placeholder="选择城市仓"
            v-model="formData.logistics_id"
            @change="onChangeCityStore"
            :filter-method="(val) => onFilterMethod('cityStore', val)"
            @visible-change="(val) => onChangeVisible('cityStore', val)"
            filterable
            clearable
          >
            <el-option
              v-for="item in cityStoreList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="inputs">
         
          <el-select
            class="jn-input-style"
            placeholder="选择自提点"
            v-model="formData.delivery_id"
            :filter-method="(val) => onFilterMethod('selfTake', val)"
            @visible-change="(val) => onChangeVisible('selfTake', val)"
            filterable
            clearable
          >
            <el-option
              v-for="item in selfTakeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="inputs">
         
          <el-input
            class="jn-input-style"
            v-model="formData.buyer_name"
            placeholder="请输入业务员姓名"
            clearable
          ></el-input>
        </div>
        <div class="inputs">
          <el-select
            class="jn-input-style"
            v-model="formData.supplier_id"
            clearable
            filterable
            placeholder="请选择供应商"
          >
            <el-option
              v-for="item in supplierList"
              :label="item.title"
              :key="item.id"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="inputs">
      
          <el-select
            class="jn-input-style multiple-select-long"
            placeholder="选择售后状态"
            v-model="formData.process_list"
            collapse-tags
            filterable
            multiple
            clearable
          >
            <li
              class="el-select-dropdown__item"
              :class="{
                selected: formData.process_list.length === stateList.length,
              }"
              @click="onHandleSelectedAll"
            >
              <span>全选</span>
            </li>
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="inputs">
          <el-input
            class="jn-input-style"
            v-model="formData.supplier_order_no"
            placeholder="请输入供货单号"
            clearable
          ></el-input>
        </div>
        <div class="inputs">
          <el-select
            class="jn-input-style"
            v-model="formData.team_id"
            clearable
            filterable
            multiple
            collapse-tags
            placeholder="请选择组名"
          >
            <el-option
              v-for="item in getinittableData"
              :label="item.team_name"
              :key="item.id"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <el-button @click="onHandleSearch" type="primary" icon="el-icon-search"
          >查询</el-button
        >
        <el-button
          :disabled="!tableData.length || disabledExport"
          @click="onHandleExport"
          type="warning"
          icon="el-icon-download"
          >导出</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 5px"
          icon="el-icon-refresh"
          class="bjsearch"
          @click="onHandleRefresh"
        ></el-button>
      </div>
    </div> -->
    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
          ref="table"
        v-loading="loading"
          @header-dragend="handleHeaderDragEnd"
        :key="tableKey"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
       
         <el-table-column
          v-for="column in columns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          :show-overflow-tooltip="column.showoverflowtooltip"
          align="center"
          :fixed="column.fixed"
          :min-width="column.minWidth"
        >
          <template slot-scope="scope">
            <span v-if="column.prop == 'goods_name'">
              {{ getGoodsName(scope.row.aftersale) }}</span
            >
            <span v-else-if="column.prop == 'reason_name'">{{
              getReason(scope.row.aftersale)
            }}</span>
            <span v-else-if="column.prop == 'sku_code'">{{
              scope.row.sku_code
            }}</span>
            <span v-else-if="column.prop == 'supplier_create_at'">{{
              scope.row.supplier_create_at
            }}</span>
            <span v-else-if="column.prop == 'star_customer_grade_detail'">{{
              scope.row.star_customer_grade_detail
            }}</span>
            <span v-else-if="column.prop == 'member_name'">
              {{ getMemberName(scope.row.aftersale) }}</span
            >
            <span v-else-if="column.prop == 'member_mobile'">
              {{ getMemberMobile(scope.row.aftersale) }}</span
            >
            <span v-else-if="column.prop == 'logistics_name'">
              {{ getLogisticsName(scope.row.aftersale) }}</span
            >
            <span v-else-if="column.prop == 'delivery_name'">
              {{ getDeliveryName(scope.row.aftersale) }}</span
            >
            <span v-else-if="column.prop == 'supplier_name'">
              {{ getSupplierName(scope.row.aftersale) }}</span
            >
            <span v-else-if="column.prop == 'buyer_name'">
              {{ getSupplierBuyerName(scope.row.aftersale) }}</span
            >
            <span v-else-if="column.prop == 'logistic_business_name'">
              {{ scope.row.logistic_business_name || "-" }}</span
            >
            <span v-else-if="column.prop == 'create_time'">
              {{ scope.row.create_time || "-" }}</span
            >
            <span v-else-if="column.prop == 'as_no'">
              {{
                (scope.row.aftersale && scope.row.aftersale.as_no) || "-"
              }}</span
            >
            <span v-else-if="column.prop == 'order_no'">
              {{
                (scope.row.aftersale && scope.row.aftersale.order_no) || "-"
              }}</span
            >
            <span v-else-if="column.prop == 'cate_name'">
              {{ scope.row.cate_name }}</span
            >
  <span v-else-if="column.prop == 'process_name'"> {{ scope.row.process_name || "-" }}</span>
  <span v-else> {{ scope.row[column.prop]}}</span>
            
          </template>
        </el-table-column>
       
       
       
        <el-table-column
          label="操作"
          :min-width="is_force_intervene ? 220 : 150"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="d-flex" style="justify-content: space-around">
              <router-link
                style="white-space: nowrap"
                :to="{
                  name: 'newAfterDetail',
                  query: { id: scope.row.as_id, state: scope.row.state },
                }"
                class="main-color pointer text-none"
                >查看详情
              </router-link>
              <template v-if="is_force_intervene">
                <div
                  style="white-space: nowrap"
                  v-show="scope.row.aftersale.state === 0"
                  class="main-color pointer"
                  @click="
                    dialogFormVisible = true;
                    as_id = scope.row.as_id;
                  "
                >
                  强制介入
                </div>
                <div
                  style="white-space: nowrap; color: rgba(0, 0, 0, 0.3)"
                  v-show="scope.row.aftersale.state > 0"
                  class="main-color"
                >
                  强制介入
                </div>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--  审核拒绝弹出框  -->
    <el-dialog
      title="强制介入"
      :visible.sync="dialogFormVisible"
      v-if="dialogFormVisible"
      width="60%"
      class="dialog"
      center
    >
      <div class="contents1">
        <div class="mb-10 font-weight">
          此售后将转到平台介入中，请输入介入原因，此原因城市仓、供货商可查看
        </div>
        <el-input
          type="textarea"
          v-model="refuseReason"
          :autosize="{ minRows: 10 }"
          placeholder="填写介入原因"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            dialogFormVisible = false;
            refuseReason = '';
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="submitFrom">确认</el-button>
      </span>
    </el-dialog>
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { postRegionalManagerSelectList } from "@/api/general/manager.js";
import cloneDeep from "lodash/cloneDeep";
import debounce from "lodash/debounce";
import { Loading } from "element-ui";
import { getSubList, postForceIntervene } from "@/api/generalControl/index.js";
import { getAftersaleProcessMap } from "@/api/general/sale-after";
import Filtersearch from "@/components/Filtersearch.vue";
import Sortable from "sortablejs";
import {
  LOSS_REASON_ENUM,
  IS_TDC_SUBMIT,
  CUSTOMER_TYPE_ENUM,
  WAREHOUSE_TYPE_ENUM,
} from "./utils/enum/index";
import { postUnAfterSaleExport } from "@/api/export/center";
import { formatDate } from "@/utils/tools/date.js";
import { getSupplierSelectList ,postBuyerSelectList,} from "@/api/general/operation-center/index";

export default {
  name: "UnPlatformParticipation",
  components: { Filtersearch },
  data() {
    return {
      loading: false,
      is_force_intervene: false, //是否强制介入
      dialogFormVisible: false, //强制介入弹窗
      refuseReason: "", //售后原因
      as_id: "", //售后id
      reasonList: Object.values(LOSS_REASON_ENUM), // 售后原因
      subCidList: [], // 二级分类列表
      businessList: [], // 集配中心列表
      cityStoreList: [], // 城市仓列表
      selfTakeList: [], // 自提点列表
      stateList: [], // 售后状态
      createDate: [], // 售后创建日期对象
      finishDate: [], // 售后完成日期对象
      payDate: [], // 订单支付时间对象
      supplierDate: [], // 供货日期
      tableKey: 0, // 用于强制重新渲染表格
      sortableInstance: null, // Sortable 实例
      columns: [
        {
          label: "组名",
          prop: "clientele_services_team_name",
          fixed: "left",
          minWidth: "180",
        },
         {
          label: "区域经理",
          prop: "regional_manager_name",
          fixed: "left",
          minWidth: "150",
        },
        {
          label: "商品名称",
          prop: "goods_name",
          fixed: "left",
          minWidth: "150",
        },
        { label: "售后原因", prop: "reason_name", minWidth: "150" },
        { label: "货号", prop: "sku_code", minWidth: "150" },
        { label: "供货日期", prop: "supplier_create_at", minWidth: "150" },
        {
          label: "客户等级",
          prop: "star_customer_grade_detail",
          minWidth: "150",
        },
        { label: "客户名称", prop: "member_name", minWidth: "150" },
        { label: "客户电话", prop: "member_mobile", minWidth: "150" },
        { label: "城市仓", prop: "logistics_name", minWidth: "150" },
        { label: "自提点", prop: "delivery_name", minWidth: "150" },
        { label: "供货商", prop: "supplier_name", minWidth: "150" },
        { label: "业务员", prop: "buyer_name", minWidth: "150" },
        { label: "集配中心", prop: "logistic_business_name", minWidth: "150" },
        { label: "创建时间", prop: "create_time", minWidth: "150" },
        {
          label: "售后单号",
          prop: "as_no",
          minWidth: "80",
          showoverflowtooltip: true,
        },
        {
          label: "订单号",
          prop: "order_no",
          minWidth: "80",
          showoverflowtooltip: true,
        },
        { label: "二级分类", prop: "cate_name", minWidth: "150" },
        {
          label: "售后状态",
          prop: "process_name",
          fixed: "right",
          minWidth: "80",
        },
      ],
      Filtersearchlist: [
        {
          type: "selectAll",
          name: "售后状态",
          clearable: true,
          filterable: true,
           multiple: true,
          model: "process_list",
          placeholder: "请选择售后状态",
          label: "label",
          value: "value",
          selectoption: [],
        },
        {
          type: "input",
          name: "客户电话",
          clearable: true,
          model: "mobile",
          placeholder: "请输入客户电话",
        },
        {
          type: "input",
          name: "客户姓名",
          clearable: true,
          model: "fullname",
          placeholder: "请输入客户姓名",
        },
        

       {
          type: "input",
          name: "订单号",
          clearable: true,
          model: "order_no",
          placeholder: "请输入订单号",
        },
        {
          type: "input",
          name: "售后单号",
          clearable: true,
          model: "as_no",
          placeholder: "请输入售后单号",
        },

        {
          type: "select",
          name: "客户等级",
          clearable: true,
          filterable: true,
          model: "member_grade",
          placeholder: "请选择客户等级",
          selectoptionname: "customer_grade",
          label: "value",
          value: "key",
          selectoption: [],
        },
        {
          type: "select",
          name: "组名",
          clearable: true,
          filterable: true,
          multiple: true,
          model: "team_id",
          placeholder: "请选择组名",
          selectoptionname: "team_id_list",
          label: "team_name",
          value: "id",
          selectoption: [],
        },
        {
          type: "input",
          name: "货号",
          clearable: true,
          model: "sku_code",
          placeholder: "请输入货号",
        },
        {
          type: "select",
          name: "客户类型",
          clearable: true,
          filterable: true,
          model: "membership_status",
          placeholder: "请选择客户类型",
          label: "label",
          value: "value",
          selectoption: Object.values(CUSTOMER_TYPE_ENUM),
        },
       
        {
          type: "select",
          name: "二级品类",
          clearable: true,
          filterable: true,
          model: "cid",
          placeholder: "请选择二级品类",
          selectoptionname: "cid_list",
          label: "name",
          value: "id",
          selectoption: [],
        },
 
{
          type: "select",
          name: "售后原因",
          clearable: true,
          filterable: true,
          multiple: true,
          model: "reason_type",
          placeholder: "请选择售后原因",
          label: "label",
          value: "value",
          selectoption: Object.values(LOSS_REASON_ENUM),
        },
        {
          type: "input",
          name: "商品名称",
          clearable: true,
          model: "title",
          placeholder: "请输入商品名称",
        },
        {
          type: "selectChange",
          name: "城市仓",
          clearable: true,
          filterable: true,
          model: "logistics_id",
          placeholder: "请选择城市仓",
          selectoptionname: "cityStoreList",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "自提点",
          clearable: true,
          filterable: true,
          model: "delivery_id",
          placeholder: "请选择自提点",
          selectoptionname: "selflist",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "供应商",
          clearable: true,
          filterable: true,
          model: "supplier_id",
          placeholder: "请选择供应商",
          selectoptionname: "supplier_id_list",
          label: "title",
          value: "id",
          selectoption: [],
        },
        // {
        //   type: "select",
        //   name: "业务员",
        //   clearable: true,
        //   filterable: true,
        //   model: "buyer_id",
        //   placeholder: "请选择业务员",
        //   selectoptionname: "buyerList",
        //   label: "fullname",
        //   value: "id",
        //   selectoption: [],
        // },
        {
         type: "input",
          name: "业务员",
          clearable: true,
          model: "buyer_name",
          placeholder: "请输入业务员",
        },
        {
          type: "input",
          name: "供货单号",
          clearable: true,
          model: "supplier_order_no",
          placeholder: "请输入供货单号",
        },
        {
          type: "select",
          name: "提报类型",
          clearable: true,
          filterable: true,
          model: "is_tdc_submit",
          placeholder: "请选择提报类型",
          label: "label",
          value: "value",
          selectoption: Object.values(IS_TDC_SUBMIT),
        },
        // {
        //   type: "select",
        //   name: "仓主专区",
        //   clearable: true,
        //   filterable: true,
        //   model: "is_tdc_owner",
        //   placeholder: "请选择仓主专区",
        //   label: "label",
        //   value: "value",
        //   selectoption: Object.values(WAREHOUSE_TYPE_ENUM),
        // },
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logistic_business_id",
          placeholder: "请选择集配中心",
          selectoptionname: "logistic_business_list",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "daterange",
          name: "供货日期",
          clearable: true,
          model: "supplier_time",
          startmodel: "supplier_time_start",
          endmodel: "supplier_time_end",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
          // 时间范围
          pickerOptions: 1,
          defaultValue:this.calculateDefaultDateRange(),
          clearableWith: "create_time_start", // 选择了创建日期时，供货日期可清除不传
        },
        {
          type: "daterange",
          name: "创建日期",
          clearable: true,
          model: "create_time",
          startmodel: "create_time_start",
          endmodel: "create_time_end",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
          // 时间范围
          pickerOptions: 1,
        },
        {
          type: "daterange",
          name: "完成日期",
          clearable: true,
          model: "operator_at",
          startmodel: "operator_at_start",
          endmodel: "operator_at_end",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
          // 时间范围
          pickerOptions: 1,
        },
        {
          type: "daterange",
          name: "支付日期",
          clearable: true,
          model: "pay_at",
          startmodel: "pay_at_start",
          endmodel: "pay_at_end",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
          // 时间范围
          pickerOptions: 1,
        },
            {
          type: "select",
          name: "区域经理",
          clearable: true,
          filterable: true,
          model: "regional_manager_id",
          placeholder: "请选择区域经理",
          selectoptionname: "managerList",
          label: "fullname",
          value: "id",
          selectoption: [],
        },
      ],

      formData: {
        regional_manager_id:'',
        supplier_order_no: "", //供货单号
        membership_status: "", // 会员类型
        is_tdc_owner: "", // 是否为仓主专区
        create_time_start: "", // 售后创建日期
        create_time_end: "", // 售后创建日期
        // create_end_time: "", // 售后创建结束日期
        operator_at_start: "", // 售后完成日期
        operator_at_end: "", // 售后完成日期
        // finish_end_time: "", // 售后完成结束日期
        pay_at_start: "", // 订单支付日期
        pay_at_end: "", // 订单支付日期
        // pay_end_time: "", // 订单支付结束日期
        supplier_time_start: "", // 供货日期
        supplier_time_end: "", // 供货日期
        // supplier_end_time: "", // 供货结束日期
        order_no: "", // 订单号
        as_no: "", // 售后单号
        mobile: "", // 客户电话
        title: "", // 商品名称
        sku_code: "", // 货号
        cid: "", // 二级分类
        reason_type: [], // 售后原因
        process_list: [], // 售后原因
        logistic_business_id: "", // 集配中心
        status: "", // 审批状态
        logistics_id: "", // 城市仓
        delivery_id: "", // 自提点
        buyer_name: "", // 业务员
        supplier_name: "", // 供应商
        is_tdc_submit: "", // 是否城市仓提报
        team_name: "", //
        fullname: "", //
        team_id: [],
        member_grade: "",
        sn: "",
        buyer_id: "",
        supplier_id: "",
        page: 1,
        pageSize: 10,
      }, // 表单数据
      formDataClone: {}, // 复制一份，用于初始化
      tableData: [],
      total: 0,
      getinittableData: [],
      supplierList: [],
      // 时间范围
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      disabledExport: false, // 导出禁用
    };
  },
  computed: {
    /**
     * 获得供货商名称
     */
    getSupplierName() {
      return (data) => {
        const res = data?.aftersale_detail?.order_detail?.supplier?.title;
        return res || "-";
      };
    },
    /**
     * 获得业务员名称
     */
    getSupplierBuyerName() {
      return (data) => {
        const res = data?.aftersale_detail?.order_detail?.buyer?.fullname;
        return res || "-";
      };
    },
    /**
     * 获得城市仓名称
     */
    getLogisticsName() {
      return (data) => {
        const res = data?.order?.store_delivery?.logistics?.name;
        return res || "-";
      };
    },
    /**
     * 获得自提点名称
     */
    getDeliveryName() {
      return (data) => {
        const res = data?.order?.store_delivery?.name;
        return res || "-";
      };
    },
    /**
     * 获得客户名称
     */
    getMemberName() {
      return (data) => {
        const res = data?.member?.fullname;
        return res || "-";
      };
    },
    /**
     * 获得客服电话
     */
    getMemberMobile() {
      return (data) => {
        const res = data?.member?.mobile;
        return res || "-";
      };
    },
    /**
     * 获得商品名称
     */
    getGoodsName() {
      return (data) => {
        const res = data?.aftersale_detail?.order_detail?.title;
        return res || "-";
      };
    },
    /**
     * 获得售后原因
     */
    getReason() {
      return (data) => {
        const type = data?.aftersale_detail?.reason_type;
        const res =
          type && this.reasonList.find((item) => item.value === type)?.label;
        return res || "-";
      };
    },
  },
  mounted() {
     this.formData.supplier_time = [this.getThreeMonthAgoDate(), formatDate()];
    this.formData.supplier_time_start = this.getThreeMonthAgoDate();
    this.formData.supplier_time_end = formatDate();
    // this.formData.supplier_time = `${this.supplierDate?.[0] || ""},${
    //   this.supplierDate?.[1] || ""
    // }`;
    this.formDataClone = cloneDeep(this.formData);
    // 路径有参数 搜索数据回显
    if (window.location.href.indexOf("?") > -1) {
      /** 历史丢参问题，修复 start */
      const url = this.tool.getUrl(window.location.href);
      // 无效的值
      const invalid = ["", null, undefined, "null", "undefined"];
      url.page = (invalid.includes(url.page) && 1) || url.page;
      url.pageSize = (invalid.includes(url.pageSize) && 10) || url.pageSize;
      /** 历史丢参问题，修复 end */
      this.formData = url;
      // // 供货日期
      // this.supplierDate = this.formData.supplier_time
      //   ? this.formData.supplier_time
      //   : [];
      // this.formData.supplier_time =
      //   this.formData.supplier_time.length > 0
      //     ? this.formData.supplier_time.join(",")
      //     : "";
      // // 支付日期
      // this.payDate = this.formData.pay_at ? this.formData.pay_at : [];
      // this.formData.pay_at =
      //   this.formData.pay_at.length > 0 ? this.formData.pay_at.join(",") : "";
      // // 创建日期
      // this.createDate = this.formData.create_time
      //   ? this.formData.create_time
      //   : [];
      // this.formData.create_time =
      //   this.formData.create_time.length > 0
      //     ? this.formData.create_time.join(",")
      //     : "";
      // // 完成日期
      // this.finishDate = this.formData.operator_at
      //   ? this.formData.operator_at
      //   : [];
      // this.formData.operator_at =
      //   this.formData.operator_at.length > 0
      //     ? this.formData.operator_at.join(",")
      //     : "";
      //页数和页码
      this.formData.page = Number(this.formData.page);
      this.formData.pageSize = Number(this.formData.pageSize);

      // this.formData.team_id = this.formData.team_id
      //   ? Number(this.formData.team_id)
      //   : "";
      this.formData.membership_status = this.formData.membership_status
        ? Number(this.formData.membership_status)
        : "";
      this.formData.supplier_id = this.formData.supplier_id
        ? Number(this.formData.supplier_id)
        : "";
      this.formData.buyer_id = this.formData.buyer_id
        ? Number(this.formData.buyer_id)
        : "";
      this.formData.is_tdc_submit = this.formData.is_tdc_submit
        ? Number(this.formData.is_tdc_submit)
        : "";
      this.formData.is_tdc_owner = this.formData.is_tdc_owner
        ? Number(this.formData.is_tdc_owner)
        : "";
      this.formData.regional_manager_id = this.formData.regional_manager_id
        ? Number(this.formData.regional_manager_id)
        : "";
      // 城市仓和自提点
      if (this.formData.logistics_id) {
        this.formData.logistics_id = Number(this.formData.logistics_id);
        const params = {
          name: "",
          logisticsId: this.formData.logistics_id,
        };
        this.ajaxGetSelfTakeList(params); // 请求自提点列表
        this.formData.delivery_id = this.formData.delivery_id
          ? Number(this.formData.delivery_id)
          : ""; //
        // this.cityStoreList = this.formData.cityStoreList; //回显选中城市仓列表
        // this.selfTakeList = this.formData.selfTakeList; // 回显选中自提点列表
        // delete this.formData.cityStoreList;
        // delete this.formData.selfTakeList;
      } else {
        // delete this.formData.cityStoreList;
        // delete this.formData.selfTakeList;
      }
      this.formData.status = this.formData.status
        ? Number(this.formData.status)
        : ""; // 审批状态
      this.formData.logistic_business_id = this.formData.logistic_business_id
        ? Number(this.formData.logistic_business_id)
        : ""; // 集配中心
      // this.businessList = this.formData.businessList; // 回显集配中心列表
      // delete this.formData.businessList;
      this.formData.reason_type = this.formData.reason_type;
      // this.subCidList = this.formData.subCidList; // 回显分类列表
      // delete this.formData.subCidList;
      this.formData.cid = this.formData.cid ? Number(this.formData.cid) : ""; // 二级分类
      console.log(this.formData, url, "===");
    }
 this.getfavoriteslist();
    this.postAjaxBuyerSelectList();
    this.getinit();
    this.onInitData();
    this.initSortable();
    this.postAjaxRegionalManagerSelectList();
  },
  methods: {
            // 区域经理下拉
    async postAjaxRegionalManagerSelectList() {
      try {
        const res = await postRegionalManagerSelectList();
        console.log(res, "res==");
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "managerList"
          ) {
            el.selectoption = [...res.data];
          }
        });

        console.log(this.Filtersearchlist, "333");
      } catch (error) {
        console.log(error, "postRegionalManagerSelectList");
      }
    },
        calculateDefaultDateRange() {
      const now = new Date();
      const startOfMonth = now.getFullYear()+"-"+ (now.getMonth()+1) +"-"+ 1; // 当前月的第一天
      const endOfMonth = now.getFullYear()+"-"+ (now.getMonth()+1) +"-"+  now.getDate(); // 当前月的最后一天
      return [startOfMonth, endOfMonth]; // 返回一个包含开始和结束日期的数组
    },
     // 调整宽度 保存宽度
    handleHeaderDragEnd(newWidth, oldWidth, column, event) {
      console.log(newWidth, oldWidth, column, event, column.property, "122");
      // 保存调整后的列宽度
      const columnIndex = this.columns.findIndex(
        (col) => col.prop === column.property
      );
      console.log(columnIndex, "33columnIndex");
      if (columnIndex !== -1) {
        this.columns[columnIndex].minWidth = newWidth;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
        this.initSortable();
      }
    },
    // 拖拽表格列
    initSortable() {
      this.$nextTick(() => {
        if (this.sortableInstance) {
          this.sortableInstance.destroy(); // 销毁之前的实例
        }
        const el = this.$refs.table.$el.querySelector(
          ".el-table__header-wrapper tr"
        );

        this.sortableInstance = Sortable.create(el, {
          onEnd: (evt) => {
            console.log(evt, this.columns, "ve---");

            const movedItem = this.columns.splice(evt.oldIndex, 1)[0];
            console.log(movedItem, "eee", evt.oldIndex);
            this.columns.splice(evt.newIndex, 0, movedItem);
            console.log(this.columns, "表格数据变更");
            // 强制重新渲染表格
            this.tableKey += 1;

            // 重新初始化 Sortable
            this.initSortable();
          },
          animation: 150,
          ghostClass: "sortable-ghost",
          onStart: (evt) => {
            if (this.columns[evt.oldIndex].fixed) {
              return false; // 禁止固定列的拖动
            }
          },
        });
      });
    },
    getfavoriteslist() {
      this.$api.aftersale.favoriteslist().then((res) => {
        // console.log(res,'1213')
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            res.data[el.selectoptionname]
          ) {
            // console.log(el.selectoptionname,res.data[el.selectoptionname])
            if (el.multiple) {
              el.selectoption = [...res.data[el.selectoptionname]];
            } else {
              el.selectoption = [
                // { value: "全部", key: "" },
                ...res.data[el.selectoptionname],
              ];
            }
          }
        });
      });
    },
    /**
     * 获取业务下拉列
     */
    async postAjaxBuyerSelectList() {
      // this.loadingBuyerList = true;
      try {
        const { data } = await postBuyerSelectList();

        // this.Filtersearchlist.forEach((el) => {
        //   if (
        //     el.type == "select" &&
        //     el.selectoptionname &&
        //     el.selectoptionname == "buyerList"
        //   ) {
        //     el.selectoption = [...data];
        //   }
        // });
      } catch (err) {
        console.log("ajax postBuyerSelectList err", err);
      } finally {
        // this.loadingBuyerList = false;
      }
    },
    /**
     * 获取供应商下拉列
     */
    async ajaxGetSupplierSelectList() {
      try {
        const { data } = await getSupplierSelectList();
        this.supplierList = data;
         this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "supplier_id_list"
          ) {
            // console.log(el.selectoptionname,res.data[el.selectoptionname])

            el.selectoption = data;
          }
        });
      } catch (err) {
        console.log("ajax getSupplierSelectList err", err);
      } finally {
      }
    },
    getinit() {
      this.ajaxGetSupplierSelectList();
      this.$api.customer
        .servicesteamlist({ page: 1, pageSize: 999999 })
        .then((res) => {
          this.getinittableData = res.data.data;
           this.Filtersearchlist.forEach((el) => {
            if (
              el.type == "select" &&
              el.selectoptionname &&
              el.selectoptionname == "team_id_list"
            ) {
              // console.log(el.selectoptionname,res.data[el.selectoptionname])

              el.selectoption = res.data.data;
            }
          });
        });
    },
    querySearchAsync(queryString, cb) {
      console.log(this.formData.team_name, "this.formData.team_name");
      if (this.formData.team_name) {
        this.$api.customer
          .servicesteamlist({
            team_name: this.formData.team_name, //	是	pi模糊查询
            page: 1,
            pageSize: 999999999999,
          })
          .then((res) => {
            // this.typemethod(type, queryString, res, i);
            console.log(res.data.data, "res.data.data");
            let arr = res.data.data.map((el) => {
              return {
                value: el.team_name,
              };
            });
            cb(arr ? arr : []);
          });
      } else {
        cb([]);
      }
    },
        cityChange(val) {
      console.log(val, "1231231231231231243");
      this.selfTakeList = [];
      this.Filtersearchlist.forEach((el) => {
        if (
          el.type == "select" &&
          el.selectoptionname &&
          el.selectoptionname == "selflist"
        ) {
          el.selectoption = [];
        }
      });
      this.$refs.Filtersearchref.from.delivery_id = "";
      // this.formData.deliveryId = "1";
      const params = {
        name: "",
        logisticsId: val,
      };
      this.ajaxGetSelfTakeList(params);
    },
    // 获取近3月
    getThreeMonthAgoDate() {
      const today = new Date();
      const threeMonthsAgo = new Date(today.setMonth(today.getMonth() - 3));
      return formatDate(threeMonthsAgo);
    },
    /**
     * 初始化数据
     */
    onInitData() {
      this.ajaxGetSaleList();
      this.ajaxGetCityStoreList();
      this.ajaxGetBusinessList();
      this.ajaxGetSubList();
      this.ajaxGetAfterSaleProcessMap();
    },
    /**
     * 搜索参数添加到路径
     */
    redirectPath() {
      let tmpData = { ...this.formData };
      // tmpData.supplier_time = this.formData.supplier_time
      //   ? this.supplierDate
      //   : [];
      // tmpData.operator_at = this.formData.operator_at ? this.finishDate : [];
      // tmpData.create_time = this.formData.create_time ? this.createDate : [];
      // tmpData.pay_at = this.formData.pay_at ? this.payDate : [];
      // let arr = this.subCidList.filter((item) => item.id == this.formData.cid);
      // tmpData.subCidList = arr; // 获取选中分类列表
      // let arr1 = this.businessList.filter(
      //   (item) => item.id == this.formData.logistic_business_id
      // );
      // tmpData.businessList = arr1; // 获取选中集配中心列表
      // let arr2 = this.cityStoreList.filter(
      //   (item) => item.id == this.formData.logistics_id
      // );
      // let arr3 = [];
      // if (this.formData.logistics_id) {
      //   arr3 = this.selfTakeList.filter(
      //     (item) => item.id == this.formData.delivery_id
      //   );
      // }
      // tmpData.cityStoreList = arr2; // 获取选中城市仓列表
      // tmpData.selfTakeList = arr3; // 获取选中自提点列表
      // let arr4 = [];
      // this.formData.process_list.map((item) => {
      //   this.stateList.map((i) => {
      //     if (i.value == item) {
      //       arr4.push(i);
      //     }
      //   });
      // });
      // tmpData.stateList = arr4; // 获取选中售后状态列表
      this.tool.getResult(tmpData, window.location.href);
      console.log(this.formData, tmpData, "=555==");
    },
    /**
     * 获得集配中心列表
     */
    async ajaxGetBusinessList() {
      try {
        const { data } = await this.$api.general.businessList();
        this.businessList = data;
         this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "logistic_business_list"
          ) {
            // console.log(el.selectoptionname,res.data[el.selectoptionname])

            el.selectoption = data;
          }
        });
        console.log("ajax ajaxGetBusinessList", data);
      } catch (err) {
        console.log("ajax ajaxGetBusinessList err", err);
      }
    },
    /**
     * 获取二级分类列表
     */
    async ajaxGetSubList() {
      try {
        const { data } = await getSubList();
        this.subCidList = data;
         this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "cid_list"
          ) {
            // console.log(el.selectoptionname,res.data[el.selectoptionname])

            el.selectoption = data;
          }
        });
        console.log("ajax ajaxGetSubList", data);
      } catch (err) {
        console.log("ajax ajaxGetSubList err", err);
      }
    },
    /**
     * 获取售后状态列表
     */
    async ajaxGetAfterSaleProcessMap() {
      try {
        const { data } = await getAftersaleProcessMap();
        this.stateList = Object.keys(data).map((_KEY) => {
          return {
            value: _KEY,
            label: data[_KEY],
          };
        });
            this.Filtersearchlist.forEach((el) => {
          if (
            el.model == "process_list"
          ) {
            el.selectoption =  this.stateList ;
          }
        });
      } catch (err) {
        console.log("ajax ajaxGetAfterSaleProcessMap err", err);
      }
    },
    /**
     * 查询表单
     */
    search(e) {
      this.formData = e;
      // 创建日期为空且供货日期为空时，恢复供货日期默认值
      if (!this.formData.create_time_start && !this.formData.supplier_time_start) {
        const defaultRange = this.calculateDefaultDateRange();
        this.formData.supplier_time = defaultRange;
        this.formData.supplier_time_start = defaultRange[0];
        this.formData.supplier_time_end = defaultRange[1];
      }
      // 重置数据第一页
      this.formData.page = 1;
      this.redirectPath();
      this.ajaxGetSaleList();
    },
    /**
     * 重置数据
     */
    Refresh() {
     
      this.formData = {
        ...this.formDataClone,
      };
       this.formData.supplier_time = [this.getThreeMonthAgoDate(), formatDate()];
      this.formData.supplier_time_start = this.getThreeMonthAgoDate();
      this.formData.supplier_time_end = formatDate();
      this.selfTakeList = [];
      this.createDate = [];
      this.finishDate = [];
      this.payDate = [];
       this.Filtersearchlist.forEach((el) => {
        if (
          el.type == "select" &&
          el.selectoptionname &&
          el.selectoptionname == "selflist"
        ) {
          el.selectoption = [];
        }
      });
      // this.supplierDate = [];
      this.redirectPath();
      this.ajaxGetSaleList();
    },
    /**
     * 导出数据（下载中心）
     */
    async onHandleExport() {
      /** 旧导出逻辑 */
      // this.disabledExport = true;
      // this.$message.success("正在导出，请耐心等待");
      // try {
      //   const params = {
      //     ...this.formData,
      //   };
      //   delete params.page;
      //   delete params.pageSize;
      //   const res = await getAfterSaleNewUnExport(params);
      //   downLoadFlowBlob(res, res?.filename);
      // } catch (err) {
      //   this.$message.error("导出失败了");
      //   console.log("ajax getAfterSaleNewUnExport err", err);
      // } finally {
      //   this.disabledExport = false;
      // }
      /** 新导出逻辑 */
      this.disabledExport = true;
      try {
        const query = {
          ...this.formData,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;
        await postUnAfterSaleExport(query);
        this.goExportCenter();
      } catch (err) {
        console.log("ajax postUnAfterSaleExport err", err);
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    /**
     * 修改了每页数据条数
     */
    onHandleSizeChange(val) {
      this.formData.page = 1;
      this.formData.pageSize = val;
      this.redirectPath();
      this.ajaxGetSaleList();
    },
    /**
     * 修改了页码
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.redirectPath();
      this.ajaxGetSaleList();
    },
    /**
     * 获得列表数据
     */
    async ajaxGetSaleList() {
      this.loading = true;
      const params = {
        ...this.formData,
      };
      try {
        const { data } = await this.$api.general.salenewunlist(params);
        const { is_force_intervene, total, data: list } = data;
        this.tableData = list;
        this.total = total;
        this.is_force_intervene = is_force_intervene;
      } catch (err) {
        console.log("ajax ajaxGetSaleList err", err);
      } finally {
        this.loading = false;
      }
    },
    /**
     * 售后创建日期发生变化
     */
    changeCreateDate(data) {
      this.formData.create_time = `${data?.[0] || ""},${data?.[1] || ""}`;
      // this.formData.create_start_time = data?.[0] || "";
      // this.formData.create_end_time = data?.[1] || "";
    },
    /**
     * 售后完成日期发生变化
     */
    changeFinishDate(data) {
      this.formData.operator_at = `${data?.[0] || ""},${data?.[1] || ""}`;
      // this.formData.finish_start_time = data?.[0] || "";
      // this.formData.finish_end_time = data?.[1] || "";
    },
    /**
     * 支付日期发生变化
     */
    changePayDate(data) {
      this.formData.pay_at = `${data?.[0] || ""},${data?.[1] || ""}`;
      // this.formData.pay_start_time = data?.[0] || "";
      // this.formData.pay_end_time = data?.[1] || "";
    },
    /**
     * 供货日期发生变化
     */
    changeSupplierDate(data) {
      this.formData.supplier_time = `${data?.[0] || ""},${data?.[1] || ""}`;
      // this.formData.supplier_start_time = data?.[0] || "";
      // this.formData.supplier_end_time = data?.[1] || "";
    },
    /**
     * 全选/反选
     */
    onHandleSelectedAll() {
      if (this.formData.process_list.length === this.stateList.length) {
        // 取消全选
        this.formData.process_list = [];
      } else {
        this.formData.process_list = this.stateList.map((item) => item.value);
      }
    },
    /**
     * 获取城市仓列表
     */
    ajaxGetCityStoreList: debounce(async function (data) {
      const params = {
        name: data,
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await this.$api.Followup.logisticsselect(params);
        this.cityStoreList = data;
         this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "selectChange" &&
            el.selectoptionname &&
            el.selectoptionname == "cityStoreList"
          ) {
            el.selectoption = [...data];
          }
        });
        console.log("ajx ajaxGetCityStoreList", data);
      } catch (err) {
        console.log("ajx ajaxGetCityStoreList err", err);
      }
    }, 500),
    /**
     * 获取自提点列表
     */
    ajaxGetSelfTakeList: debounce(async function ({
      name = "",
      logisticsId = "",
    }) {
      // /**
      //  * 城市仓为必传参数
      //  * 防止接口在删除城市仓前请求数据，故先判断条件
      //  */
      // if (!logisticsId || !this.formData.logistics_id) {
      //   return;
      // }
      const params = {
        name,
        logistics_id: (logisticsId && [logisticsId]) || [],
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await this.$api.general.deliveryList(params);
        this.selfTakeList = data.data;
         this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "selflist"
          ) {
            el.selectoption = [...data.data];
          }
        });
        console.log("ajx ajaxGetSelfTakeList", data.data);
      } catch (err) {
        console.log("ajx ajaxGetSelfTakeList err", err);
      }
    },
    500),
    /**
     * 城市仓发生变化
     */
    onChangeCityStore(data) {
      // 重置自提点
      this.selfTakeList = [];
      this.formData.delivery_id = "";
      const params = {
        name: "",
        logisticsId: data,
      };
      this.ajaxGetSelfTakeList(params);
    },
    /**
     * 搜索数据项
     */
    onFilterMethod(type, data) {
      if (type === "cityStore") {
        this.ajaxGetCityStoreList(data);
      }
      if (type === "selfTake") {
        const params = {
          name: data,
          logisticsId: this.formData.logistics_id,
        };
        this.ajaxGetSelfTakeList(params);
      }
    },
    /**
     * 失焦时，初始化下拉框
     */
    onChangeVisible(type, data) {
      if (!data && type === "cityStore") {
        this.ajaxGetCityStoreList();
      }
      if (!data && type === "selfTake") {
        const params = {
          name: "",
          logisticsId: this.formData.logistics_id,
        };
        this.ajaxGetSelfTakeList(params);
      }
    },
    /**
     * 强制介入提交表单
     */
    submitFrom() {
      this.$confirm("是否强制介入", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(async () => {
        this.load = Loading.service({ fullscreen: true });
        let params = {
          after_id: this.as_id,
          remark: this.refuseReason,
        };
        try {
          await postForceIntervene(params);
          this.ajaxGetSaleList();
          this.refuseReason = "";
          this.tool.message(`已强制介入`, "success");
        } catch (error) {
          console.error("postForceIntervene", error);
        } finally {
          this.dialogFormVisible = false;
          this.load.close();
        }
      });
    },
  },
};
</script>

<style lang="scss">
.unplatfollow-wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .contents1 {
    box-sizing: border-box;
    padding: 10px 26px 40px;
    text-align: center;

    .span {
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #349ee6;
      padding: 4px 13px 4px 0;
      box-sizing: border-box;
      background: #f5f7fa;
      display: flex;
      align-content: center;
      margin-bottom: 20px;

      .w {
        width: 3px;
        background-color: #349ee6;
        margin-right: 13px;
      }
    }

    .el-form-item__content {
      margin-left: 0px !important;
    }
  }
  .order-wrapper {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 20px;
    background: #ffffff;
    padding: 20px;
    .inputs {
      display: flex;
      .label {
        line-height: 38px;
      }
    }
  }
  .title {
    background: #ffffff;
    box-sizing: border-box;
    display: flex;
    .bjsearch {
      background: #333333;
      border-color: #333333;
      margin-right: 10px;
    }
  }
  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }
  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }
  .multiple-select-long {
    width: 320px;
    .el-select__input {
      height: auto;
    }
  }
}

/deep/ .el-select {
  width: 240px;
  height: 36px;
  .el-input {
    width: 100%;
    height: 100%;
    &__inner {
      width: 100%;
      height: 100% !important;
    }
  }
}
</style>
